import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../ClientForm/Form/reviewForm.css";
import {
  Button,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Spin,
  Form,
  Row,
  Col,
} from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { FaCalendarAlt } from "react-icons/fa";
import { setClientFormData, setClientFormStruc } from "../../Redux/ClientFormSlice";
import {
  SubmitClientForm,
  getAllCountries,
  getProclozBillingEntityDropdown,
  addProclozBillingEntity,
  getCurrencyDropdown,
  extractClientDocument,
} from "../../services/ApiService";
import { NumericFormat } from "react-number-format";
const { Option } = Select;

const ClientOnboardForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [isProclozOthersSelected, setIsProclozOthersSelected] = useState(false);
  const [proclozBillingEntities, setProclozBillingEntities] = useState([]);
  const [countryIdOptions, setCountryIdOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [msaFile, setMsaFile] = useState(null);
  const [sowFile, setSowFile] = useState(null);
  const [isDocsModalVisible, setIsDocsModalVisible] = useState(true);
  const [isExtracting, setIsExtracting] = useState(false);
  const [form] = Form.useForm();
  const formData = useSelector((state) => state.Clientform.ClientformData);
  const formStructure = useSelector(
    (state) => state.Clientform.ClientformStructure
  );

  if (!formStructure || Object.keys(formStructure).length === 0) {
    navigate("/clientList");
  }

  useEffect(() => {
    const fetchCountryOptions = async () => {
      try {
        const response = await getAllCountries(1);
        const rawObjects = response?.country_list ?? [];

        const sortedRawObjects = [...rawObjects].sort((a, b) =>
          (a.country_name || "").localeCompare(b.country_name || "")
        );

        const countryOptions = sortedRawObjects.map((item) => {
          // item.country_name is something like "Afghanistan(AF)"
          const fullString = item.country_name || "";
          const cleanName = fullString.split("(")[0].trim();

          return {
            label: fullString,
            value: cleanName,
          };
        });

        const countryIdOptionsList = sortedRawObjects.map((item) => {
          const fullString = item.country_name || "";
          const cleanName = fullString.split("(")[0].trim();

          return {
            label: cleanName,
            value: item.id,
          };
        });
        setCountryIdOptions(countryIdOptionsList);

        const updatedStructure = JSON.parse(JSON.stringify(formStructure));

        Object.keys(updatedStructure).forEach((stepKey) => {
          updatedStructure[stepKey].forEach((section) => {
            Object.values(section).forEach((fields) => {
              fields.forEach((field) => {
                if (field.id === 131) {
                  field.option = countryOptions;
                }
              });
            });
          });
        });

        dispatch(setClientFormStruc(updatedStructure));
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    fetchCountryOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchProclozBillingEntities = async () => {
      try {
        const response = await getProclozBillingEntityDropdown();
        setProclozBillingEntities(response?.procloz_billing_entities || []);
      } catch (error) {
        console.error("Error fetching Procloz billing entities:", error);
      }
    };

    fetchProclozBillingEntities();
  }, []);

  useEffect(() => {
    const fetchCurrencyOptions = async () => {
      try {
        const response = await getCurrencyDropdown();
        setCurrencyOptions(response?.currencies || []);
      } catch (error) {
        console.error("Error fetching currency dropdown:", error);
      }
    };

    fetchCurrencyOptions();
  }, []);

  const setFieldData = (payload) => {
    dispatch(setClientFormData(payload));
  };

  const handleFormChange = (value, name) => {
    setFieldData({ name, value });
    form.setFieldsValue({ [name]: value });
  };

  useEffect(() => {
    const currentEntityValue = formData["procloz_billing_entity"];
    if (!currentEntityValue || proclozBillingEntities.length === 0) return;

    const matched = proclozBillingEntities.find(
      (entity) => String(entity.id) === String(currentEntityValue)
    );

    if (matched) {
      setIsProclozOthersSelected(false);
      if (formData["procloz_billing_entity_country_id"] !== matched.country_id) {
        handleFormChange(matched.country_id, "procloz_billing_entity_country_id");
      }
    } else {
      setIsProclozOthersSelected(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proclozBillingEntities, formData["procloz_billing_entity"]]);

  const handleSubmit = async (values) => {
    try {
      setloading(true);
      let finalData = { ...formData };
      
      if (isProclozOthersSelected) {
        const entityRes = await addProclozBillingEntity({
          billing_entity: formData["procloz_billing_entity"],
          country_id: formData["procloz_billing_entity_country_id"],
        });
        const newEntity = entityRes?.data;
        if (!newEntity?.id) {
          message.error(
            entityRes?.responseMessage ||
              "Failed to create Procloz billing entity."
          );
          setloading(false);
          return;
        }
        finalData.procloz_billing_entity = newEntity.id;
        finalData.procloz_billing_entity_country_id = newEntity.country_id;
      }

      const formDataPayload = new FormData();
      formDataPayload.append('data', JSON.stringify(finalData));
      if (msaFile) formDataPayload.append('msa_file', msaFile);
      if (sowFile) formDataPayload.append('sow_file', sowFile);

      let res = await SubmitClientForm(formDataPayload);

      if (res.responseCode === 200) {
        message.success(res.responseMessage);
        navigate("/clientList");
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong. Please try again.");
    } finally {
      setloading(false);
    }
  };

  const handleSave = async () => {
    form
      .validateFields()
      .then(() => {
        Modal.confirm({
          title: "Are you sure?",
          content:
            "If you save the details, your request will be shown in the Directory.",
          okText: "Yes, Submit!",
          okType: "danger",
          cancelText: "Cancel",
          centered: true,
          onOk: () => form.submit(),
        });
      })
      .catch((errorInfo) => {
        message.error("Please fix validation errors before submitting.");
        const firstErrorField = errorInfo?.errorFields?.[0]?.name;
        if (firstErrorField) {
          form.scrollToField(firstErrorField, {
            behavior: "smooth",
            block: "center",
          });
        }
      });
  };

  const renderField = (fieldName, fieldData) => {
    const rules = [
      {
        required: fieldData.required,
        message: `${fieldData.label} is required`,
      },
    ];

    if (fieldData.input_type === "number") {
      rules.push({
        pattern: /^[0-9+\- ]+$/,
        message: "Only numbers, '+', '-' and spaces are allowed",
      });
    }

    if (fieldData.input_type === "alphabet") {
      rules.push({
        pattern: /^[A-Za-z.\s]+$/,
        message: "Only alphabets are allowed",
      });
    }

    return (
      <Form.Item
        key={fieldName}
        name={fieldName}
        label={fieldData.label}
        rules={rules}
        initialValue={formData[fieldName] || ""}
      >
        {fieldData.input_type === "text" ? (
          <Input
            className="clientinput-box"
            placeholder={fieldData.placeholder}
            onChange={(e) => handleFormChange(e.target.value, fieldName)}
          />
        ) : fieldData.input_type === "amount" ? (
          <NumericFormat
            className="input-box"
            placeholder={fieldData.placeholder}
            value={formData[fieldName] || ""}
            thousandSeparator={true}
            thousandsGroupStyle="lakh"
            decimalScale={2}
            allowNegative={false}
            customInput={Input}
            valueIsNumericString={true}
            type="text"
            onValueChange={(values) => {
              const raw = values.value;
              handleFormChange(raw, fieldName);
            }}
          />
        ) : fieldData.input_type === "number" ? (
          <Input
            type="text"
            inputMode="numeric"
            pattern="[0-9+\- ]*"
            className="clientinput-box"
            value={formData[fieldName] || ""}
            onChange={(e) => {
              const v = e.target.value;
              const cleaned = v.replace(/[^0-9+\- ]/g, "");
              handleFormChange(cleaned, fieldName);
            }}
          />
        ) : fieldName === "icp_billing_currency" ? (
          <Select
            className="clientinput-box"
            showSearch
            allowClear
            placeholder={fieldData.placeholder}
            onChange={(selectedValue) =>
              handleFormChange(selectedValue, fieldName)
            }
          >
            {currencyOptions.map((currency) => (
              <Option key={currency} value={currency}>
                {currency}
              </Option>
            ))}
          </Select>
        ) : fieldData.input_type === "alphabet" ? (
          <Input
            className="clientinput-box"
            placeholder={fieldData.placeholder}
            onChange={(e) => {
              const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              handleFormChange(onlyAlphabets, fieldName);
            }}
          />
        ) : fieldName === "procloz_billing_entity" ? (
          <div className="procloz-billing-group">
            <Select
              className="procloz-country-select"
              showSearch
              allowClear
              placeholder="Country"
              value={formData["procloz_billing_entity_country_id"] || undefined}
              onChange={(value) =>
                handleFormChange(value, "procloz_billing_entity_country_id")
              }
              options={countryIdOptions}
              optionFilterProp="label"
            />
            {isProclozOthersSelected ? (
              <Input
                className="procloz-entity-control"
                placeholder="Enter Procloz Billing Entity"
                value={formData[fieldName] ?? ""}
                suffix={
                  <span
                    style={{
                      cursor: "pointer",
                      color: "red",
                      fontSize: "1rem",
                      marginRight: "4px",
                    }}
                    onClick={() => {
                      setIsProclozOthersSelected(false);
                      form.setFieldsValue({ [fieldName]: "" });
                      handleFormChange("", fieldName);
                    }}
                  >
                    x
                  </span>
                }
                onChange={(e) => handleFormChange(e.target.value, fieldName)}
              />
            ) : (
              <Select
                className="procloz-entity-control"
                showSearch
                allowClear
                placeholder={fieldData.placeholder}
                value={formData[fieldName] || undefined}
                onChange={(selectedValue) => {
                  if (selectedValue === "Other") {
                    setIsProclozOthersSelected(true);
                    form.setFieldsValue({ [fieldName]: "" });
                    handleFormChange("", fieldName);
                  } else {
                    handleFormChange(selectedValue, fieldName);
                    const matched = proclozBillingEntities.find(
                      (entity) => String(entity.id) === String(selectedValue)
                    );
                    if (matched) {
                      form.setFieldsValue({
                        procloz_billing_entity_country_id: matched.country_id,
                      });
                      handleFormChange(
                        matched.country_id,
                        "procloz_billing_entity_country_id"
                      );
                    }
                  }
                }}
              >
                {proclozBillingEntities.map((entity) => (
                  <Option key={entity.id} value={entity.id}>
                    {entity.billing_entity}
                  </Option>
                ))}
                <Option value="Other">Other</Option>
              </Select>
            )}
          </div>
        ) : fieldData.input_type === "select" ? (
          <Select
            className="clientinput-box"
            showSearch
            allowClear
            placeholder={fieldData.placeholder}
            onChange={(selectedValue) => {
              if (
                fieldName === "procloz_billing_entity" &&
                selectedValue === "Other"
              ) {
                setIsProclozOthersSelected(true);
                form.setFieldsValue({ [fieldName]: "" });
                handleFormChange("", fieldName);
              } else {
                handleFormChange(selectedValue, fieldName);
              }
            }}
          >
            {fieldData.option.map((option, idx) =>
              typeof option === "string" ? (
                <Option key={idx} value={option}>
                  {option}
                </Option>
              ) : (
                <Option key={idx} value={option.value}>
                  {option.label}
                </Option>
              )
            )}
          </Select>
        ) : fieldData.input_type === "date" ? (
          <DatePicker
            className="clientinput-box"
            selected={
              formData[fieldName] &&
              !isNaN(new Date(formData[fieldName]).getTime())
                ? new Date(formData[fieldName])
                : null
            }
            onChange={(date) => {
              const formattedDate = date
                ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
                    2,
                    "0"
                  )}-${String(date.getDate()).padStart(2, "0")}`
                : "";
              handleFormChange(formattedDate, fieldName);
              form.setFieldsValue({ [fieldName]: formattedDate });
            }}
            dateFormat="yyyy-MM-dd"
            customInput={<Input suffix={<FaCalendarAlt />} />}
          />
        ) : fieldData.input_type === "radio" ? (
          <Radio.Group
            className="clientinput-box"
            onChange={(e) => handleFormChange(e.target.value, fieldName)}
          >
            {fieldData.option.map((option, i) => (
              <Radio key={i} value={option}>
                {option}
              </Radio>
            ))}
          </Radio.Group>
        ) : null}
      </Form.Item>
    );
  };

  const renderSection = (sectionName, sectionData) => {
    const fields = [];

    const renderFieldWithConditionals = (field) => {
      fields.push(renderField(field.name, field));

      const value = formData[field.id];
      if (
        field.conditional_fields &&
        field.conditional_fields[value] &&
        Array.isArray(field.conditional_fields[value])
      ) {
        field.conditional_fields[value].forEach((nestedField) => {
          renderFieldWithConditionals(nestedField);
        });
      }
    };

    sectionData.forEach((field) => {
      renderFieldWithConditionals(field);
    });

    return (
      <div key={sectionName} className="Reviewsection">
        <h3 className="section-title">{sectionName.replace(/_/g, " ")}</h3>

        {/* max 3 fields per row */}
        <Row gutter={[16, 16]}>
          {fields.map((field, idx) => (
            <Col span={8} key={idx}>
              {field}
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  const handleProceedToForm = async () => {
    setIsExtracting(true);
    try {
      const extractPayload = new FormData();
      if (msaFile) extractPayload.append("msa_file", msaFile);
      if (sowFile) extractPayload.append("sow_file", sowFile);

      const res = await extractClientDocument(extractPayload);

      if (res?.responseCode === 200 && res.extracted_fields) {
        Object.entries(res.extracted_fields).forEach(([name, value]) => {
          if (value !== null && value !== undefined) {
            handleFormChange(value, name);
          }
        });
      } else if (res?.responseMessage) {
        message.warning(res.responseMessage);
      }
    } catch (error) {
      console.error("Error extracting document data:", error);
      message.warning(
        "Could not auto-extract data from the document. Please fill the form manually."
      );
    } finally {
      setIsExtracting(false);
      setIsDocsModalVisible(false);
    }
  };

  const handleBackClick = () => {
    Modal.confirm({
      title: "Are you sure?",
      content: "If you go back now, all unsaved data will be lost.",
      okText: "Yes, Go Back",
      okType: "danger",
      cancelText: "Cancel",
      centered: true,
      onOk() {
        navigate("/clientList");
      },
    });
  };

  return (
    <>
      <Modal
        title="Upload Required Documents"
        open={isDocsModalVisible}
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            key="back"
            disabled={isExtracting}
            onClick={() => navigate("/clientList")}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!msaFile}
            loading={isExtracting}
            onClick={handleProceedToForm}
          >
            Proceed to Form
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 16 }}>
          <p>Please upload the foundational documents to proceed with Client Creation.</p>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label><strong>Master Service Agreement (MSA) <span style={{color: 'red'}}>*</span></strong></label>
          <Input type="file" accept=".pdf,.doc,.docx" disabled={isExtracting} onChange={(e) => setMsaFile(e.target.files[0])} />
        </div>
        <div>
          <label><strong>Statement of Work (SOW)</strong> (Optional)</label>
          <Input type="file" accept=".pdf,.doc,.docx" disabled={isExtracting} onChange={(e) => setSowFile(e.target.files[0])} />
        </div>
      </Modal>

      <div className="form-header">
        <button className="back" onClick={() => handleBackClick()}>
          <AiOutlineArrowLeft />
        </button>
        <span style={{ fontWeight: 600 }}>Client Onboard Form</span>
        {/* <span className="progress">Onboarding</span> */}
      </div>
      <hr style={{ color: "#ECEEEB", margin: "0px" }} />

      <Spin
        spinning={loading}
        size="large"
        tip="Loading..."
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "76vh",
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={formData}
          scrollToFirstError={{ behavior: "smooth", block: "center" }}
        >
          <div
            className="review-container custom-scrollbar"
            style={{ height: "74vh", marginTop: "1.5rem" }}
          >
            {Object.keys(formStructure).map((stepKey) => {
              const stepData = formStructure[stepKey];
              if (!stepData || !Array.isArray(stepData)) return null;
              return stepData.map((sectionData) => {
                const sectionName = Object.keys(sectionData)[0];
                return renderSection(sectionName, sectionData[sectionName]);
              });
            })}
          </div>

          <div className="button-container">
            <Form.Item>
              <Button
                type="primary"
                shape="round"
                onClick={() => handleSave()}
                style={{
                  backgroundColor: "#4A3AFF",
                  padding: "1.2rem",
                }}
              >
                Submit Details
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </>
  );
};

export default ClientOnboardForm;
